import React from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {updateDelete} from '../../utils/mutation';
import Query from '../../components/Query';
import Icon from '../../components/Icon';
import {MUTATION_BLOCK_DELETE, QUERY_BLOCK_LIST} from './graphql';
import Avatar from '../../components/Avatar';

const BlockList = ({forumId}) => {
  const query = useQuery(QUERY_BLOCK_LIST, {variables: {forumId}});

  const [del] = useMutation(MUTATION_BLOCK_DELETE, {
    update: (cache, response) => updateDelete(cache, response, {query: QUERY_BLOCK_LIST, variables: {forumId}}),
  });

  return (
    <div className="bg-white border rounded overflow-hidden p-3">
      <div className="row align-self-center gx-1 mb-3">
        <div className="col-auto">
          <Icon name="ban" />
        </div>
        <div className="col fw-bold">Заблокированные</div>
      </div>
      {Query(query) || (
        <div className="list-group list-group-flush border-top border-bottom">
          {query.data.blockList.map(item => (
            <div key={item.id} className="list-group-item">
              <div className="row align-items-center gx-2">
                <div className="col-auto">
                  <Avatar user={item.client.user} />
                </div>
                <div className="col">{item.client.user.fullname}</div>
                <div className="col-auto">
                  <button onClick={() => del({variables: {input: {id: item.id}}})} className="btn btn-sm p-1">
                    <Icon name="times" size={20} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlockList;
